type QueryKey = string | number | boolean | Date | undefined | null;

export const queryKeys = {
	generic: (...keys: QueryKey[]) => keys,
	eventInstance: (eventId: string, instance: string) => ['event', eventId, instance],
	eventTicketsCountAndSpots: (eventId: string, instance: string) => [
		'event-tickets-count-end-spots',
		eventId,
		instance,
	],
	userEventTicketReservations: (eventId: string, instance: string) => [
		'user-event-ticket-reservations',
		eventId,
		instance,
	],
	user: (profileId: QueryKey) => ['user', profileId],
	hostRelated: (hostId: QueryKey, ...keys: QueryKey[]) => ['host', hostId, ...keys],
	order: (orderId: QueryKey) => ['order', orderId],
	ticket: (ticketId: QueryKey) => ['ticket', ticketId],
	eventClasses: (...keys: QueryKey[]) => ['event-classes', ...keys],
	ticketClasses: (ticketId: QueryKey) => ['ticket-classes', ticketId],
	relatedEvents: (...keys: QueryKey[]) => ['events', ...keys],
	eventsDates: (...keys: QueryKey[]) => ['events-dates', ...keys],
	freeSlides: (location?: string) => ['freeSlides', location ?? ''],
	slides: (location?: string) => ['slides', location ?? ''],
	location: (location?: string) => ['location', location ?? ''],
	hostMemberships: (communityId?: string) => ['host-membership-tiers', communityId],
	eventMemberships: (communityId?: string) => ['event-membership-tiers', communityId],
	userMemberships: (...keys: QueryKey[]) => ['user-memberships', ...keys],
	unsubscribe: (communityId?: string) => ['unsubscribe', communityId],
	systemSettings: (...keys: QueryKey[]) => ['system-settings', ...keys],
};
